import { render, staticRenderFns } from "./FixDriverChat.vue?vue&type=template&id=043c946e&scoped=true&"
import script from "./FixDriverChat.vue?vue&type=script&lang=js&"
export * from "./FixDriverChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043c946e",
  null
  
)

export default component.exports